import React from 'react';
import { View, StyleSheet } from 'react-native';
import TouchableHighlight from 'utils/packages/TouchableHighlight';
import Text from 'design-system/Text';
import Spacer from 'design-system/Spacer';
import Squircle from 'design-system/Squircle';
import { rem } from 'design-system/values';
import IconCheck from 'design-system/icons/IconCheck';
import useColors from 'hooks/useColors';
const FilterWatchListItem = ({ title, icon, onPress, isSelected }) => {
    const colors = useColors();
    return (<TouchableHighlight hoverOnLight underlayColor={colors.background.underlay} activeOpacity={1} onPress={onPress}>
      <View style={styles.container}>
        <View>
          <Squircle width={rem(44)} height={rem(44)} color={colors.background.dark}>
            {icon}
          </Squircle>
          {isSelected ? (<View style={styles.checkmark}>
              <Squircle width={rem(24)} height={rem(24)} color={colors.cards.onLight}>
                <Squircle width={rem(20)} height={rem(20)} color={colors.text.negative}>
                  <IconCheck alt color={colors.cards.onLight} width={10} height={10}/>
                </Squircle>
              </Squircle>
            </View>) : null}
        </View>
        <Spacer w={16}/>
        <Text Text-16>{title}</Text>
      </View>
    </TouchableHighlight>);
};
export default FilterWatchListItem;
const styles = StyleSheet.create({
    container: {
        padding: rem(16),
        alignItems: 'center',
        flexDirection: 'row',
    },
    checkmark: {
        right: 0,
        bottom: 0,
        width: rem(24),
        height: rem(24),
        position: 'absolute',
    },
});
